import { gql } from "@apollo/client";

export const GET_ESTADOS_MEDICO = gql`
query estadosRI{
    estadosRI {
        idEstadosRI,
        descripcion
    }
  }
`;

export const adaptEstadoMedico = (eMedico) => ({
  id: eMedico.idEstadosRI,
  displayName: eMedico.descripcion
});

export const adaptEstadosEvolucionAsistArray = (estados) =>
structuredClone(estados?.estadosRI)?.
map((eMedico) => adaptEstadoMedico(eMedico));